import React from 'react';
import styled, { css } from 'styled-components';

const BottomSheet = ({ view, phrases }) => {
  return (
    <Wrap view={view}>
      <p>{phrases}</p>
    </Wrap>
  );
};

const Wrap = styled.div`
  position: absolute;
  left: 50%;
  bottom: 45px;
  transform: translateX(-50%);
  background-color: #000;
  padding: 0 17px;
  width: fit-content;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  z-index: 999;
  > p {
    color: #fff;
    font-size: 12px;
  }

  @keyframes moveUp {
    0% {
      transform: translate(-50%, -30%);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%);
      opacity: 1;
    }
  }

  ${(props) =>
    props.view
      ? css`
          animation-duration: 0.5s;
          animation-name: moveUp;
          animation-direction: normal;
          animation-fill-mode: forwards;
        `
      : css`
          display: none;
        `}
`;

export default BottomSheet;
